import { useMutation } from "@tanstack/react-query";
import { editShipApi } from "@/API/editShipApi";
import { ShipDataType } from "@/types/apiTypes";
import { useInvalidateQueries } from "@/hooks/helperHooks/useInvalidateQueries";
import { ShowNotification } from "@/components/ShowNotification";
import { useErrorBoundary } from "@/hooks/helperHooks/useErrorBoundary";
import { useLoadingContext } from "@/hooks/contextHooks/useLoadingContext";

type EditShipParams = {
  shipId: string;
  updatedData: any;
};

export const useEditShip = () => {
  const { startLoading, stopLoading } = useLoadingContext();
  const { invalidateShips } = useInvalidateQueries();
  const handleError = useErrorBoundary();
  return useMutation<ShipDataType, Error, EditShipParams>({
    mutationFn: ({ shipId, updatedData }) => editShipApi(shipId, updatedData),
    onMutate: () => {
      startLoading();
    },
    onSuccess: () => {
      invalidateShips();
      stopLoading();
      ShowNotification({
        title: "Success",
        message: "Ship details updated successfully.",
        color: "success",
      });
    },
    onError: (error: Error) => {
      stopLoading();

      ShowNotification({
        title: "Error",
        message: "Failed to update ship details.",
        color: "error",
      });
      handleError(error);
    },
  });
};
